// document.addEventListener('DOMContentLoaded', function () {
//     const parallaxElm = document.querySelector('.banner-parallax');
//     if (parallaxElm) {
//         // Function to apply the parallax effect
//         function applyParallaxEffect(parallaxElement) {
//             window.addEventListener('scroll', function () {
//                 var scrollPosition = window.scrollY;

//                 // Adjust this value to make the element move faster relative to the scroll
//                 var parallaxSpeed = -0.1; // The element will move faster than the scroll

//                 // Move the element based on the scroll position, same direction as scroll
//                 parallaxElement.style.transform = 'translateY(' + (scrollPosition * parallaxSpeed) + 'px)';
//             });
//         }

//         // Function to handle intersection changes
//         function handleIntersect(entries, observer) {
//             entries.forEach(entry => {
//                 if (entry.isIntersecting) {
//                     // When the element is in the viewport, apply the parallax effect
//                     applyParallaxEffect(entry.target);
//                 }
//             });
//         }

//         // Set up the IntersectionObserver
//         const observerOptions = {
//             root: null, // Use the viewport as the root
//             threshold: 0.1 // Trigger when 10% of the element is visible
//         };

//         const observer = new IntersectionObserver(handleIntersect, observerOptions);

//         // Initialize the observer on existing elements
//         const parallaxElements = document.querySelectorAll('.banner-parallax');
//         parallaxElements.forEach(parallaxElement => {
//             observer.observe(parallaxElement);
//         });

//         // MutationObserver to handle dynamically added .banner-parallax elements
//         const mutationObserver = new MutationObserver(function (mutations) {
//             mutations.forEach(function (mutation) {
//                 mutation.addedNodes.forEach(function (node) {
//                     if (node.nodeType === 1 && node.classList.contains('banner-parallax')) {
//                         observer.observe(node); // Observe the new element
//                     }
//                 });
//             });
//         });

//         // Start observing the document for changes in the child nodes
//         mutationObserver.observe(document.body, { childList: true, subtree: true });
//     }
// });

document.addEventListener('DOMContentLoaded', function () {
    const parallaxElm = document.querySelector('.banner-parallax');

    if (parallaxElm) {
        // Function to apply the parallax effect
        function applyParallaxEffect(parallaxElement) {
            function handleScroll() {
                if (window.innerWidth > 767) {
                    var scrollPosition = window.scrollY;

                    // Adjust this value to make the element move faster relative to the scroll
                    var parallaxSpeed = -0.1; // The element will move faster than the scroll

                    // Move the element based on the scroll position, same direction as scroll
                    parallaxElement.style.transform = 'translateY(' + (scrollPosition * parallaxSpeed) + 'px)';
                } else {
                    // Remove the parallax effect when window width is 767 or below
                    parallaxElement.style.transform = ''; // Reset to default
                }
            }

            // Apply the parallax effect on scroll
            window.addEventListener('scroll', handleScroll);

            // Also trigger the effect on window resize
            window.addEventListener('resize', function () {
                handleScroll(); // Re-check the width and adjust the parallax
            });

            // Call it once to set the initial state
            handleScroll();
        }

        // Function to handle intersection changes
        function handleIntersect(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // When the element is in the viewport, apply the parallax effect
                    applyParallaxEffect(entry.target);
                }
            });
        }

        // Set up the IntersectionObserver
        const observerOptions = {
            root: null, // Use the viewport as the root
            threshold: 0.1 // Trigger when 10% of the element is visible
        };

        const observer = new IntersectionObserver(handleIntersect, observerOptions);

        // Initialize the observer on existing elements
        const parallaxElements = document.querySelectorAll('.banner-parallax');
        parallaxElements.forEach(parallaxElement => {
            observer.observe(parallaxElement);
        });

        // MutationObserver to handle dynamically added .banner-parallax elements
        const mutationObserver = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (node.nodeType === 1 && node.classList.contains('banner-parallax')) {
                        observer.observe(node); // Observe the new element
                    }
                });
            });
        });

        // Start observing the document for changes in the child nodes
        mutationObserver.observe(document.body, { childList: true, subtree: true });
    }
});
